import { mutations as TYPES } from "./types";

const mutations = {
  [TYPES.SET_SURVEY_DATA](state, { type, data }) {
    state.survey[type] = data
  },
  [TYPES.SET_FURTHER_SURVEY_DATA](state, { type, data }) {
    const survey = state.survey[type];
    const hasAnswer = data.answer?.length;

    hasAnswer
      ? survey.furtherSurvey = data
      : delete survey.furtherSurvey
  },
  [TYPES.RESET_SURVEY_DATA](state, { type }) {
    state.survey[type] = null;
  }
};

export default mutations;
